import { API_ROOT } from '../config/ApiConfig';
import { IMS_CLIENT_ID } from '../service/ApiService';

export async function checkPPBHealth(): Promise<boolean> {
  try {
    const response = await fetch(`${API_ROOT}/health?api_key=${IMS_CLIENT_ID}`);
    return response.ok;
  } catch {
    return false;
  }
}
